import { optional } from 'AppReact/schema';

export default {
    name: optional('string'),
    nameError: optional('string'),
}
